export const PUBLIC_ROUTE = {
  LANDING: "/",
  LOGIN: "/login",
  PAGE_404: "/404",
  PAGE_500: "/500",
};

export const PRIVATE_ROUTE = {
  BUSINESS_INFO: "business-info",
  HOME: "home",
  DASHBOARD: "dashboard",
  TEMPLATE_MGNT: "template-management",
  TEMPLATE: "template",
  SETTINGS: "settings",
  BUSINESS_INFORMATION: "business-information",
  TERMS_CONDITIONS: "terms-conditions",
  PAYMENT_METHODS: "payment-methods",
  DELIVERY_AREA: "delivery-area",
  DATA_MGNT: "data-mgnt",
  PRODUCTS: "products",
  PRODUCT_DETAILS: "product-details",
  EDIT_PRODUCT: "edit-product",
  EDIT_PRODUCT_OPTIONS: "edit-product-options",
  EDIT_PRICE: "edit-price",
  CATEGORIES: "categories",
  CATALOGUES: "catalogues",
  ORDER_MGNT: "order-mgnt",
  ORDERS: "orders",
  ORDER_DETAILS: "order-details",
  EDIT_TEMPLATE: "edit-template",
  STOCK_MGNT: "stock-mgnt",
  STOCK_INVENTORY_REPORT: "stock-inventory-report",
  USER_MANAGEMENT: "user-management",
  REPORTS: "reports",
  ADMIN_REPORT: "admin-report",
  USER_REPORT: "user-report",
  INCOME_REPORT: "income-report",
  ORDER_REPORT: "order-report",
  ADMINS: "admins",
  BRAND: "brand",
  PAYMENT_TERMS_CONDITIONS: "payment-terms-conditions",
  PROFILE: "profile",
  PAY_HOSTING_FEE: "pay-hosting-fee",
  BEST_SELLING_PRODUCTS: "best-selling-products",
  CUSTOMER_LOGIN_METHODS: "customer-login-methods",
  CANCEL_REASON: "cancel-reason",
  DELIVERY_AREA_TERMS:"delivery-terms",
  WELCOME_MESSAGE:"welcome-message",
  OPT_USAGE_REPORT:"otp-usage",
  NOTIFICATION:"notifications",
  PAYMENT:"payment",
  PAYMENTAUTO:"payment-auto",
  PAYMENTMANUAL:"payment-manual",
  EXCHANGERATE:"exchange-rate",
  MAINTENANCE:"maintenance",
  RECIVINGACCOUNT:"reciving-account",
  PAYMENTREPORT:"payment-report",
  PAYMENTREPORTDETAILS:"payment-report-details",
  WITHDRAWREPORTS:"withdraw-reports",
  SLIDER_CONFIG:"slider-configs",
  OPENING_HOURS:"opening-hours",
  STEPUP_STORE:"stepup-store",
  SOCIAL_CONTACT:"social-contact",
  PROFIT_REPORT:"profit-report",
  ITEMS_PROFIT:"items-profits",
  ADD_PACKAGE:"add-package",
  PRODUCT_OPTIONS:"product-options"
};
